function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M76 240c12.102 0 23.055-4.855 31.148-12.652l44.403 22.199c-.223 1.808-.551 3.586-.551 5.453 0 24.813 20.188 45 45 45s45-20.188 45-45c0-6.926-1.703-13.41-4.512-19.277l60.235-60.235C302.59 178.297 309.074 180 316 180c24.813 0 45-20.188 45-45 0-4.672-.918-9.09-2.246-13.328L411.09 82.43C418.23 87.2 426.79 90 436 90c24.813 0 45-20.188 45-45S460.812 0 436 0s-45 20.188-45 45c0 4.672.918 9.09 2.246 13.328L340.91 97.57C333.77 92.8 325.21 90 316 90c-24.813 0-45 20.188-45 45 0 6.926 1.703 13.41 4.512 19.277l-60.235 60.235C209.41 211.703 202.926 210 196 210c-12.102 0-23.055 4.855-31.148 12.652l-44.403-22.199c.223-1.808.551-3.586.551-5.453 0-24.813-20.187-45-45-45s-45 20.188-45 45 20.188 45 45 45zm0 0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M497 482h-16V165c0-8.29-6.71-15-15-15h-60c-8.29 0-15 6.71-15 15v317h-30V255c0-8.29-6.71-15-15-15h-60c-8.29 0-15 6.71-15 15v227h-30V375c0-8.29-6.71-15-15-15h-60c-8.29 0-15 6.71-15 15v107h-30V315c0-8.29-6.71-15-15-15H46c-8.29 0-15 6.71-15 15v167H15c-8.29 0-15 6.71-15 15s6.71 15 15 15h482c8.29 0 15-6.71 15-15s-6.71-15-15-15zm0 0"
});

var SvgChartCombo = function SvgChartCombo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChartCombo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chart_combo.cffe2d26.svg";
export { ForwardRef as ReactComponent };